import React from "react";
import { PiSpinnerGap } from "react-icons/pi";
import "./Loading.css";

const Loading: React.FC = () => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <PiSpinnerGap className="loading-spinner" />
        <h1>Loading...</h1>
        <p>Please wait while we load your data.</p>
      </div>
    </div>
  );
};

export default Loading;
